import { render } from "./FindYourLegacyPolicy.vue?vue&type=template&id=70e952e4&scoped=true"
import script from "./FindYourLegacyPolicy.vue?vue&type=script&lang=js"
export * from "./FindYourLegacyPolicy.vue?vue&type=script&lang=js"

import "./FindYourLegacyPolicy.vue?vue&type=style&index=0&id=70e952e4&lang=css"
import "./FindYourLegacyPolicy.vue?vue&type=style&index=1&id=70e952e4&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e952e4"]])

export default __exports__